import React from "react";

import { MenuItem, Select } from "@mui/material";
import { SelectProps } from "@mui/material/Select/Select";

import { IgIconComponent } from "./IgIconComponent";

type IgSelectProps = SelectProps & {
  placeholder?: string;
};

export const IgSelect = (props: IgSelectProps) => {
  const { children, placeholder, sx, ...rest } = props;

  return (
    <Select
      // color={"secondary"}
      sx={{
        backgroundColor: "white",
        ...sx,
      }}
      IconComponent={IgIconComponent}
      {...rest}
    >
      {placeholder ? (
        <MenuItem sx={{ display: "none" }} value={"ig-empty"}>
          {placeholder}
        </MenuItem>
      ) : null}
      {children}
    </Select>
  );
};
